var _g, _g2, _g3, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivationStepsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.37369,
    y: -12.581,
    width: 52.618,
    height: 65.1708
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.65px)",
      clipPath: "url(#bgblur_0_1722_20007_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1722_20007)",
    "data-figma-bg-blur-radius": 13.3079
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0022,
    height: 38.555,
    rx: 5.19978,
    transform: "matrix(-1 0 0 1 34.9364 0.726944)",
    fill: "#FDFDFD",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.537976,
    y: 0.537976,
    width: 24.9262,
    height: 37.479,
    rx: 4.66181,
    transform: "matrix(-1 0 0 1 33.8604 0.726944)",
    stroke: "url(#paint0_linear_1722_20007)",
    strokeWidth: 1.07595
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.07991,
    cy: 2.07991,
    r: 2.07991,
    transform: "matrix(-1 0 0 1 24.8504 31.4324)",
    fill: "url(#paint1_linear_1722_20007)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.07991,
    cy: 2.07991,
    r: 2.07991,
    transform: "matrix(-1 0 0 1 24.8504 31.4324)",
    fill: "black",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.67074,
    y: 2.30422,
    width: 33.0218,
    height: 33.4381
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.77px)",
      clipPath: "url(#bgblur_1_1722_20007_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1722_20007)",
    "data-figma-bg-blur-radius": 5.54989
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9221,
    height: 22.3383,
    rx: 4.41278,
    transform: "matrix(-1 0 0 1 22.8012 7.85411)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.124938,
    y: 0.124938,
    width: 21.6722,
    height: 22.0884,
    rx: 4.28784,
    transform: "matrix(-1 0 0 1 22.5513 7.85411)",
    stroke: "url(#paint2_linear_1722_20007)",
    strokeOpacity: 0.5,
    strokeWidth: 0.249876
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4476 23.2543C6.4476 22.5182 6.59259 21.7893 6.8743 21.1092C7.156 20.4291 7.5689 19.8111 8.08941 19.2906C8.60993 18.7701 9.22788 18.3572 9.90797 18.0755C10.5881 17.7938 11.317 17.6488 12.0531 17.6488C12.7892 17.6488 13.5181 17.7938 14.1982 18.0755C14.8783 18.3572 15.4963 18.7701 16.0168 19.2906C16.5373 19.8111 16.9502 20.4291 17.2319 21.1092C17.5136 21.7893 17.6586 22.5182 17.6586 23.2543L12.0531 23.2543H6.4476Z",
    fill: "url(#paint3_linear_1722_20007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4476 23.2543C6.4476 22.5182 6.59259 21.7893 6.8743 21.1092C7.156 20.4291 7.5689 19.8111 8.08941 19.2906C8.60993 18.7701 9.22788 18.3572 9.90797 18.0755C10.5881 17.7938 11.317 17.6488 12.0531 17.6488C12.7892 17.6488 13.5181 17.7938 14.1982 18.0755C14.8783 18.3572 15.4963 18.7701 16.0168 19.2906C16.5373 19.8111 16.9502 20.4291 17.2319 21.1092C17.5136 21.7893 17.6586 22.5182 17.6586 23.2543L12.0531 23.2543H6.4476Z",
    fill: "black",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.73699,
    cy: 3.73699,
    r: 3.73699,
    transform: "matrix(-1 0 0 1 15.7903 12.0438)",
    fill: "#619D94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33812 18.3498C10.0192 19.0691 10.9833 19.5178 12.0521 19.5178C13.121 19.5178 14.0851 19.069 14.7662 18.3496C14.5823 18.2478 14.3924 18.1563 14.1975 18.0755C13.5174 17.7938 12.7885 17.6488 12.0524 17.6488C11.3162 17.6488 10.5873 17.7938 9.90722 18.0755C9.71213 18.1563 9.52215 18.2479 9.33812 18.3498Z",
    fill: "url(#paint4_linear_1722_20007)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33812 18.3498C10.0192 19.0691 10.9833 19.5178 12.0521 19.5178C13.121 19.5178 14.0851 19.069 14.7662 18.3496C14.5823 18.2478 14.3924 18.1563 14.1975 18.0755C13.5174 17.7938 12.7885 17.6488 12.0524 17.6488C11.3162 17.6488 10.5873 17.7938 9.90722 18.0755C9.71213 18.1563 9.52215 18.2479 9.33812 18.3498Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6489 9.62863C16.6416 9.41722 16.8071 9.23995 17.0185 9.23268L20.3041 9.11978C20.3922 9.11675 20.4661 9.18571 20.4691 9.2738L20.4746 9.4332C20.4746 9.43326 20.4747 9.43331 20.4747 9.43331C20.4748 9.43331 20.4748 9.43335 20.4748 9.43341L20.5932 12.8784C20.6005 13.0898 20.435 13.2671 20.2236 13.2743L19.458 13.3007C19.2466 13.3079 19.0693 13.1424 19.0621 12.931L18.9985 11.0809C18.9912 10.8694 18.8139 10.704 18.6025 10.7112L17.0712 10.7638C16.8598 10.7711 16.6825 10.6056 16.6752 10.3942L16.6489 9.62863Z",
    fill: "url(#paint5_linear_1722_20007)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.006 27.1998C17.0133 27.4112 17.1906 27.5767 17.402 27.5694L20.6873 27.4565C20.7756 27.4535 20.8446 27.3795 20.8416 27.2912L20.8361 27.1317C20.8361 27.1316 20.8362 27.1314 20.8363 27.1314C20.8365 27.1314 20.8366 27.1313 20.8366 27.1312L20.7182 23.6863C20.7109 23.4749 20.5336 23.3094 20.3222 23.3167L19.5567 23.343C19.3452 23.3503 19.1798 23.5275 19.187 23.7389L19.2506 25.5897C19.2579 25.8011 19.0924 25.9783 18.881 25.9856L17.3494 26.0382C17.138 26.0455 16.9725 26.2228 16.9797 26.4342L17.006 27.1998Z",
    fill: "url(#paint6_linear_1722_20007)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69668 9.75109C7.68942 9.53969 7.51215 9.37419 7.30074 9.38146L4.23843 9.48669C4.02702 9.49396 3.86153 9.67123 3.86879 9.88264L3.90825 11.031C3.90825 11.031 3.90825 11.031 3.90826 11.031C3.90826 11.031 3.90826 11.031 3.90826 11.031L3.98499 13.2639C3.99225 13.4753 4.16952 13.6408 4.38093 13.6335L5.14651 13.6072C5.35792 13.5999 5.52341 13.4227 5.51615 13.2113L5.45257 11.3612C5.4453 11.1498 5.6108 10.9725 5.8222 10.9652L7.35336 10.9126C7.56476 10.9054 7.73026 10.7281 7.72299 10.5167L7.69668 9.75109Z",
    fill: "url(#paint7_linear_1722_20007)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15759 27.323C7.16485 27.5344 6.99936 27.7117 6.78795 27.719L3.72564 27.8242C3.51423 27.8315 3.33696 27.666 3.3297 27.4546L3.29024 26.3063C3.29023 26.3062 3.29026 26.3062 3.2903 26.3062C3.29034 26.3062 3.29037 26.3062 3.29037 26.3061L3.21364 24.0735C3.20638 23.8621 3.37187 23.6848 3.58328 23.6776L4.34886 23.6512C4.56027 23.644 4.73754 23.8095 4.7448 24.0209L4.80837 25.8708C4.81564 26.0822 4.99291 26.2477 5.20432 26.2404L6.73534 26.1878C6.94674 26.1805 7.12401 26.346 7.13128 26.5574L7.15759 27.323Z",
    fill: "url(#paint8_linear_1722_20007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1722_20007",
    x: -4.37369,
    y: -12.581,
    width: 52.618,
    height: 65.1708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.08311
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1722_20007"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1722_20007_clip_path",
    transform: "translate(4.37369 12.581)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0022,
    height: 38.555,
    rx: 5.19978,
    transform: "matrix(-1 0 0 1 34.9364 0.726944)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1722_20007",
    x: -4.67074,
    y: 2.30422,
    width: 33.0218,
    height: 33.4381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.38747,
    dy: 1.38747
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38747
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1722_20007"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1722_20007_clip_path",
    transform: "translate(4.67074 -2.30422)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9221,
    height: 22.3383,
    rx: 4.41278,
    transform: "matrix(-1 0 0 1 22.8012 7.85411)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1722_20007",
    x1: 1.52954,
    y1: 7.53815,
    x2: 24.1373,
    y2: 9.2915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2E675D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59716D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1722_20007",
    x1: 0.854662,
    y1: 1.16411e-8,
    x2: 4.65267,
    y2: 4.25509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1722_20007",
    x1: 0,
    y1: 0,
    x2: 17.1353,
    y2: 17.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1722_20007",
    x1: 15.3552,
    y1: 17.6488,
    x2: 11.5212,
    y2: 26.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1722_20007",
    x1: 13.651,
    y1: 17.6488,
    x2: 12.6864,
    y2: 20.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1722_20007",
    x1: 19.6774,
    y1: 9.14132,
    x2: 16.0042,
    y2: 13.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1722_20007",
    x1: 20.061,
    y1: 27.478,
    x2: 16.1168,
    y2: 23.6699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1722_20007",
    x1: 4.6421,
    y1: 9.47282,
    x2: 8.58615,
    y2: 13.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1722_20007",
    x1: 4.12931,
    y1: 27.8103,
    x2: 7.80224,
    y2: 23.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationStepsIcon);
export default __webpack_public_path__ + "static/media/activation-steps-icon.373f975de59c8a8a588342f59f848836.svg";
export { ForwardRef as ReactComponent };